import BaseCrudService from './baseCrud.service'

class UserService extends BaseCrudService {
  constructor () {
    super('user', {
      'id': false,
      'first_name': '',
      'last_name': '',
      'isIndividual': false,
      'agency_id': 0,
      'email': ''
    })
  }

  getProspects (params, ...callbacks) {
    this.getList(params, ...callbacks)
  }

  getProfile (...callbacks) {
    this.constructor.get(this.endpoints().profile, {}, ...callbacks)
  }

  updateProfile (data, ...callbacks) {
    this.constructor.post(this.endpoints().profile, data, ...callbacks)
  }

  getSettings (...callbacks) {
    this.constructor.get(this.endpoints().settings, {}, ...callbacks)
  }

  ping (data, ...callbacks) {
    this.constructor.get(this.endpoints().ping, data, ...callbacks)
  }

  setPassword (id, data, ...callbacks) {
    this.constructor.post(this.endpoints().setPassword.replace('{:id}', id), { 'password': data.np }, ...callbacks)
  }
}

export default UserService
